// Puerto verbatim de packages/hce/src/hce/paciente/fechaRelativa.ts.
export function formatearFechaRelativa(iso: string | undefined): string {
  if (!iso) return '—';
  const fecha = new Date(iso);
  if (Number.isNaN(fecha.getTime())) return '—';

  const ahora = new Date();
  const inicioHoy = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate());
  const inicioFecha = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
  const diasEnteros = Math.round((inicioHoy.getTime() - inicioFecha.getTime()) / 86_400_000);

  if (diasEnteros <= 0) return 'HOY';
  if (diasEnteros === 1) return 'AYER';
  if (diasEnteros < 7) return `HACE ${diasEnteros} DÍAS`;
  if (diasEnteros < 30) return `HACE ${Math.floor(diasEnteros / 7)} SEMANA${Math.floor(diasEnteros / 7) === 1 ? '' : 'S'}`;
  if (diasEnteros < 365) return `HACE ${Math.floor(diasEnteros / 30)} MES${Math.floor(diasEnteros / 30) === 1 ? '' : 'ES'}`;
  return `HACE ${Math.floor(diasEnteros / 365)} AÑO${Math.floor(diasEnteros / 365) === 1 ? '' : 'S'}`;
}
